// extracted by mini-css-extract-plugin
module.exports = {"floatingLogger":"FloatingLogger_floatingLogger__1PxEJ"};